import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import Navbar from './sections/Navbar';
import Hero from './sections/Hero';
import StatsBar from './sections/StatsBar';
import Features from './sections/Features';
import FeaturedProfiles from './sections/FeaturedProfiles';
import HowItWorks from './sections/HowItWorks';
import Testimonials from './sections/Testimonials';
import Pricing from './sections/Pricing';
import { CTA, Footer } from './sections/CTAFooter';

const theme = createTheme({
  palette: { mode: 'dark', primary: { main: '#D4AF37' }, secondary: { main: '#22C55E' } },
  typography: { fontFamily: '"Sora", "Outfit", "Inter", sans-serif' },
  components: {
    MuiCssBaseline: { styleOverrides: { body: { background: '#060912', scrollBehavior: 'smooth' } } },
  },
});

const LandingPage = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Navbar />

    {/* ── Add or remove blocks freely below ── */}
    <Hero />
    <StatsBar />
    <Features />
    <FeaturedProfiles />
    <HowItWorks />
    <Testimonials />
    <Pricing />
    <CTA />
    <Footer />
    {/* ── End of blocks ── */}
  </ThemeProvider>
);

export default LandingPage;
